import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';
import AccountSelect from '@/features/account/components/account-select';
import { usePrivyAccount } from '@/hooks';
import { useAccountStore } from '@/store/use-account-store';
import { useModalStore } from '@/store/use-modal-store';
import { truncateAddress } from '@/utils/format';

export default function AccountModal() {
  const { hasEmail, email, disconnect } = usePrivyAccount();

  const { t } = useTranslation();
  const address = useAccountStore((state) => state.address);

  const isOpen = useModalStore((state) => state.isAccountModalOpen);

  useEffect(() => {
    if (!address) return;
    const { authParamsByAddress, setHasAuth } = useAccountStore.getState();
    const authParams = authParamsByAddress[address];
    if (authParams && authParams.address === address) {
      setHasAuth(true);
    } else {
      setHasAuth(false);
    }
  }, [address]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) =>
        useModalStore.setState({ isAccountModalOpen: open })
      }
    >
      <DialogContent className="gap-0 border border-border bg-background p-0 sm:max-w-sm sm:rounded-none">
        <DialogHeader className="px-5 py-6">
          <DialogTitle className="text-xl text-foreground">
            {t('accountModal.account')}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-center">
            {hasEmail
              ? email ?? (address ? truncateAddress(address, 6) : '-')
              : address
                ? truncateAddress(address, 6)
                : '-'}
          </p>
          <div className="mx-auto w-full max-w-48">
            <AccountSelect selectOnly />
          </div>
        </div>
        <DialogFooter className="pt-6 sm:flex-col sm:gap-0 sm:space-x-0">
          <Button
            type="button"
            className="h-14 w-full rounded-none font-mono text-lg font-normal tracking-wider"
            onClick={() =>
              disconnect({
                onSuccess: () =>
                  useModalStore.setState({ isAccountModalOpen: false }),
              })
            }
          >
            {t('accountModal.logOut')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
